export default __webpack_public_path__ + "img/29.asset.4ae7ae8c.jpeg";